import { InputLabel, Select } from '@mui/material';
import { styled } from '@mui/system';

export const StyledPKDSelect = styled(Select)(({ theme, error }) => ({
  fontFamily            : 'Montserrat',
  '&.MuiInputBase-root' : {
    borderRadius : '8px',
  },
  '&.MuiOutlinedInput-root' : {
    borderRadius         : '8px',
    border               : 'none',
    '&.MuiSelect-select' : {
      borderRadius : '8px',
    },
    '& :hover' : {
      borderColor : 'red',
    },
  },
  '& .MuiInputBase-input, .MuiOutlinedInput-input' : {
    border       : 'none',
    borderRadius : '8px',
  },
  '& .MuiOutlinedInput-notchedOutline' : {
    border : `1px solid ${
      error ? theme.palette.primary.red75 : theme.palette.primary.gray4
    }`,
    '& :hover' : {
      border : `1px solid ${
        error ? theme.palette.primary.red75 : theme.palette.primary.gray8
      }`,
    },
  },
  '&.Mui-focused' : {
    '& .MuiOutlinedInput-notchedOutline' : {
      border : `1px solid ${
        error ? theme.palette.primary.red75 : theme.palette.primary.greenPKD
      }`,
    },
  },
}));

export const StyledPKDInputLabel = styled(InputLabel)(({ theme, error }) => ({
  '&.MuiInputLabel-root' : {
    backgroundColor : theme.palette.primary.white,
    fontFamily      : 'Montserrat',
    border          : 'none',
    '&.Mui-focused' : {
      color : error
        ? theme.palette.primary.red75
        : theme.palette.primary.greenPKD,
    },
  },
}));
